import { ReactNode } from 'react'
import { SetterOrUpdater, useRecoilValue } from 'recoil'
import styled from 'styled-components'

import termsBtn from '@/assets/img/form/terms-btn.png'
import termsBtnActive from '@/assets/img/form/terms-btn-active.png'
import EditorWrapper from '@/shared/components/Common/EditorWrapper'
import { TELECOM } from '@/shared/constants/common'
import STYLE_GUIDE from '@/shared/constants/styleGuide'
import { useModal } from '@/shared/hooks'
import { ReturnValidate } from '@/shared/hooks/useValidate'
import { refundLGTerms } from '@/shared/recoil/user/atom'
import { ValidateType } from '@/shared/recoil/validate/atom'

interface RefundTermPropType {
  state: TermsType
  setState: SetterOrUpdater<TermsType>
  validate: ReturnValidate<ValidateType>
  subTitle?: ReactNode
  telecom: Telecom
}
const REFUND_AGREE_CHECKBOX_ID = 'refund-agree-checkbox'

const RefundTerm = ({ state, setState, validate, subTitle, telecom }: RefundTermPropType) => {
  const refundTerms = useRecoilValue(refundLGTerms)
  const modal = useModal()

  const onChange = () => {
    setState(state !== 1 ? 1 : 0)
    if (state === 0) {
      validate.recoilState[1]({ valid: false, msg: '' })
    }
  }
  const handleTermsDetail = () => {
    modal.alert({
      title: `${refundTerms.LgupTitle}`,
      contents: (
        <div className="refund_modal_terms">
          <EditorWrapper dangerouslySetInnerHTML={{ __html: refundTerms.LgupTerms }} />
        </div>
      ),
      isXBtn: false,
    })
  }

  return (
    <RefundContainer>
      <RefundTermCheckboxContainer>
        <RefundTermTitle active={state === 1} htmlFor={REFUND_AGREE_CHECKBOX_ID}>
          <RefundTermCheckbox
            id={REFUND_AGREE_CHECKBOX_ID}
            type="checkbox"
            checked={state === 1}
            onChange={onChange}
          />
        </RefundTermTitle>
        <RefundTermContent>
          <RefundTermDetailLink type="button" onClick={handleTermsDetail}>
            개인정보 수집 및 이용동의(필수)
          </RefundTermDetailLink>
          {telecom === TELECOM.SKT && (
            <RefundTermSuffix htmlFor={REFUND_AGREE_CHECKBOX_ID}>
              에 동의하며 아래 내용을 모두 확인했습니다.
            </RefundTermSuffix>
          )}
        </RefundTermContent>
      </RefundTermCheckboxContainer>
      {subTitle && <RefundTermSubTitle>{subTitle}</RefundTermSubTitle>}
    </RefundContainer>
  )
}

export default RefundTerm

const RefundContainer = styled.div`
  width: 100%;
`
const RefundTermCheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`
const RefundTermCheckbox = styled.input`
  display: none;
`
const RefundTermTitle = styled.label<{ active: boolean }>`
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  cursor: pointer;
  background: center / contain no-repeat
    url(${(props) => (props.active ? termsBtnActive : termsBtn)});
`
const RefundTermContent = styled.div`
  padding-left: 10px;
  box-sizing: border-box;
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.05em;
    line-height: 24px;
    text-align: left;
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.05em;
    text-align: left;
  }
`
const RefundTermDetailLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 16px;
  letter-spacing: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
`
const RefundTermSuffix = styled.label`
  cursor: pointer;
`
const RefundTermSubTitle = styled.p`
  @media screen and (min-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    margin: 5px 0;
    letter-spacing: -0.05em;
    text-align: left;
    padding-inline-start: 30px;
    color: ${STYLE_GUIDE.COLOR.grey03};
  }
  @media screen and (max-width: ${STYLE_GUIDE.SIZE.maxMobileSize}) {
    font-size: 16px;
    padding-left: 27px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: -0.05em;
    text-align: left;
    color: ${STYLE_GUIDE.COLOR.grey03};
  }
`
